import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { PredefinedTemplatesService } from './../../../services/edit/predefined-templates.service';
import * as $ from 'jquery';

@Component({
  selector: 'cta',
  templateUrl: './cta.component.html',
  styleUrls: ['./cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CtaComponent {
  @Input() cta: any;

  titleBack: string;
  paraBack: string;
  // Button changes.
  btnClass = 'btn btn-primary';

  private _color = 'white';
  private _background: string;
  private _imgUrl: string;
  private _backOpacity: string;
  private _filter: string;
  private _backRepeat = 'no-repeat';
  private _backAttach: string;
  private _backPos = 'center';
  private _backSize = 'cover';

  constructor(private _templateService: PredefinedTemplatesService) {}

  targetLink(targetUrl): void {
    window.open(targetUrl, '_blank');
  }

  getCTAstyles(): object {
    const result = {
      color: this.cta.color != undefined ? this.cta.color : this._color,
      'background-color': this.cta.background != undefined ? this.cta.background : this._background,
      'background-image':
        this.cta.imgUrl != 'undefined'
          ? 'url(' + this.cta.imgUrl + ')'
          : 'url(' + this._imgUrl + ')',
      opacity: this.cta.backOpacity != undefined ? this.cta.backOpacity : this._backOpacity,
      filter:
        this.cta.backOpacity != undefined
          ? 'alpha(opacity=' + this.cta.filter + ')'
          : 'alpha(opacity=' + this._filter + ')',
      'background-repeat':
        this.cta.backRepeat != undefined ? this.cta.backRepeat : this._backRepeat,
      'background-attachment':
        this.cta.backAttach != undefined ? this.cta.backAttach : this._backAttach,
      'background-position': this.cta.backPos != undefined ? this.cta.backPos : this._backPos,
      'background-size': this.cta.backSize != undefined ? this.cta.backSize : this._backSize,
    };
    return result;
  }

  onBtnFocus(event) {
    const outlineColor = this._templateService.getBtnColorForTabFocus508(event.target.className);
    if (event.target && outlineColor && outlineColor != '') {
      $(event.target).css('outline', outlineColor + ' solid');
    }
  }

  onBtnFocusOut(event) {
    if (event && event.target) {
      event.target.style.removeProperty('outline');
    }
  }
}
